<template>
  <van-form @submit="onSubmit">
    <div class='style-1' v-if='!isAdd'>
      <van-row class='style-3'>
        <van-col class='style-4'>创建时间&nbsp;&nbsp;</van-col>
        <van-col>{{ data.create_time }}</van-col>
      </van-row>
      <van-row class='style-3' v-if='isPresident'>
        <van-col class='style-4'>创建人&nbsp;&nbsp;</van-col>
        <van-col>{{ data.create_name }}</van-col>
      </van-row>
    </div>

    <template v-if='!isReplied'>
      <div class='style-1' v-if='isPresident'>
        <van-row class='style-2'>
          <van-col :span='5'>主题</van-col>
          <van-col :span='19'>{{ data.title }}</van-col>
        </van-row>
        <van-row class='style-2'>
          <van-col :span='5'>正文</van-col>
          <van-col :span='19'>{{ data.content }}</van-col>
        </van-row>
        
        <van-divider />
        <van-field v-model="data.reply_content" type='textarea'
                    name="回复" label="回复" rows="10" autosize
                    placeholder="请在此填写回复内容" :rules="[{ required: true }]"/>
      </div>
      <template v-else>
        <van-field v-model="data.title" name="主题" label="主题"
                    placeholder="请填写主题" :rules="[{ required: true }]"/>
        <van-field v-model="data.content" type='textarea'
                    name="正文" label="正文" rows="10" autosize
                    placeholder="请填写正文" :rules="[{ required: true }]"/>
      </template>
      
    </template>
    <div v-else class='style-1'>
      <!-- 原文 -->
      <van-row class='style-2'>
        <van-col :span='5'>主题</van-col>
        <van-col :span='19'>{{ data.title }}</van-col>
      </van-row>
      <van-row class='style-2'>
        <van-col :span='5'>正文</van-col>
        <van-col :span='19'>{{ data.content }}</van-col>
      </van-row>
      
      <van-divider />
      
      <!-- 回复 -->
      <van-row class='style-2 style-3'>
        <van-col>回复时间&nbsp;&nbsp;</van-col>
        <van-col>{{ data.reply_time }}</van-col>
      </van-row>
      <van-row class='style-2'>
        <van-col :span='5'>回复内容</van-col>
        <van-col :span='19'>{{ data.reply_content }}</van-col>
      </van-row>
    </div>


    <!-- 上传组件 -->
    <mail-uploader :isReplied='isReplied' :data='data'/>
    
    <template v-if='!isReplied'>
      <div class='btn-style'>
        <van-button round block type="info" native-type="submit" :loading='loading' loading-text="请稍后">
          {{ isPresident ? '回复邮件' : isAdd ? '提交邮件' : '修改邮件' }}
        </van-button>
      </div>
      <div class='btn-style' v-if='!isAdd'>
        <van-button round block type="primary" native-type="button" @click='onClickUploadBtn'>
          上传附件
        </van-button>
      </div>
    </template>
    
    <div class='btn-style'>
      <van-button round block type="warning" native-type="button" @click='onClickCancleBtn'>
        {{ isReplied ? '关闭窗口' : '取消编辑' }}
      </van-button>
    </div>
    <div class='btn-style' v-if='!isAdd && !isReplied && !isPresident'>
      <van-button plain round block type="danger" :loading='loading' loading-text="请稍后"
                  native-type="button" @click='onClickDelBtn'>
        删除此邮件
      </van-button>
    </div>
  </van-form>
</template>

<script>
import { Form, Dialog } from 'vant';
import { presidentMailAdd, presidentMailModify, presidentMailDel,
         presidentMailReply } from '@/api/presidentMailbox';
import MailUploader from './upload';
export default {
  components: { Form, Dialog, MailUploader },
  name: 'PresidentMailboxEditor',
  data() {
    return {
      isReplied: false, // 信件已答复
      loading: false
    }
  },
  props: {
    data: {
      type: Object,
      default: () => new Object()
    },
    isAdd: { // 是否新增邮件
      type: Boolean,
      default: false
    },
    isPresident: {
      type: Boolean,
      default: false
    }
  },
  created() {
    this.onCreated();
  },
  mounted() {
    if (document.getElementsByClassName('van-uploader').length) {
      document.getElementsByClassName('van-uploader')[0].style.display = 'none';
    }
  },
  methods: {
    onClickUploadBtn() {
      document.getElementsByClassName('van-uploader__input')[0].click();
    },
    onClickDelBtn() {
      Dialog.confirm({
        title: '提示',
        message: '删除后无法恢复，请确认',
      }) .then(() => { // on confirm
          const data = { id: this.data.id };

          presidentMailDel(data).then(
            resp => {
              if (resp && resp.success) {
                this.success(resp.msg);
                this.close();
                this.loading = false;
              }
            }
          );
        })
        .catch(() => { // on cancel
          
        });
    },
    onCreated() {
      if (this.data.status === 2) {
        this.isReplied = true;
      }
    },
    onSubmit() {
      this.loading = true;
      this.data.type_id = 1;

      const func = msg => {
        this.success(msg);
        this.close();
      }

      if (this.isAdd) {
        presidentMailAdd(this.data).then(resp => {
          if (resp && resp.success) {
            func(resp.msg);
            this.loading = false;
          }
        });
      } else {
        if (this.isPresident) {
          presidentMailReply(this.data).then(resp => {
            if (resp && resp.success) {
              func('已成功回复');
              this.loading = false;
            }
          });
        } else {
          presidentMailModify(this.data).then(resp => {
            if (resp && resp.success) {
              func(resp.msg);
              this.loading = false;
            }
          });
        }
      }
    },
    close() {
      this.$emit('closed');
      document.getElementsByClassName('van-popup__close-icon')[0].click();
    },
    onClickCancleBtn() {
      this.close();
    },

  }
}
</script>

<style scoped>
.style-1 {
  color: #333;
  font-size: 14px;
  padding-top: 10px;
}
.style-2 {
   padding: 15px 5px;
}
.style-3 {
   color: rgb(95, 190, 140);
}
.style-4 {
  padding-right: 10px;
  width: 90px;
  text-align: right;
}
.btn-style {
  margin: 16px;
}
#upload {
  display: none;
}
</style>


// WEBPACK FOOTER //
// src/components/president-mailbox/edit.vue